// extracted by mini-css-extract-plugin
module.exports = {"container":"loader_container__oPzUE","progress":"loader_progress__DFDS0","animate":"loader_animate__b1U1u","progressBar":"loader_progressBar__sQZbl"};